import Pill from './pill';

export default function BigPill({ onClick, removable, children }) {
    return (
        <Pill onClick={onClick} removable={removable} type="big">{ children }</Pill>
    )
}